export default function DeviceText({device}) {
	return (
		<>
			{device.name} <br />
			<b>{device.power}</b> Kwh <b>{device.time}</b> min {device.dynamic ? <><b>{device.desiredTemperature}</b> °C</> : null} pin <b>{device.pin}</b>
		</>
	);
};
